module.exports = __webpack_public_path__ + "static/img/b2567cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dy/onepart.png
// module id = 636
// module chunks = 2